export function getModuleTitle(module: any, language: any) {
  // Gets the module title from the translations based on the user language
  if (
    module &&
    module.translations &&
    module.translations[language] &&
    module.translations[language].title
  ) {
    return module.translations[language].title.replace(/\([^)]*\) *$/g, "");
  } else {
    // If the patient language is not in translations it will present the default module title
    if (module && module.title) {
      return module.title.replace(/\([^)]*\) *$/g, "");
    }
  }
}

export function generateImageUrl(module: any) {
  const host = location.host;
  const protocol = location.protocol;

  if (module && module.image) {
    return protocol + "//" + host + "/api/files/" + module.image;
  }
}

export async function getModulesCount(treatment: any) {
  if (treatment?.treatmentsModules) {
    return treatment.treatmentsModules.length;
  } else {
    return null;
  }
}

export function calculateProgressIndicatorOffset(barWidth: number, indicatorWidth: number, progressPercentage: number) {
  const maxOffset = barWidth - indicatorWidth;
  let offset = (barWidth * progressPercentage) / 100 - indicatorWidth;

  if (offset < 0) { offset = 0; }
  else if (offset > maxOffset) { offset = maxOffset; }

  return offset;
}
